import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useTranslation } from 'react-i18next';


type Props = {

}
export const HelpPageLink: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const helpPageDivStyle:React.CSSProperties = {
    marginTop: '20px',
    marginBottom: '200px',
  }
  const HelpPageLinkComponent = styled.a`
    margin-left: 260px;
    color: #FFFBFB;
    text-decoration: underline;
  `;
  return (
    <div style={helpPageDivStyle}>
        <HelpPageLinkComponent 
          // href="https://www.sushitopmarketing.com/help" 
          target="_blank"
          id="btn-default-mypage-help" 
          onClick={()=>{
            if (i18n.language == `ja`) {
              window.open(`https://www.sushitopmarketing.com/help`, `_blank`);
            }else{
              window.open(`https://sushitopmarketing.com/en/knowledge`, `_blank`);
            }
          }}
        >
          {t('ヘルプ')}
        </HelpPageLinkComponent>
    </div>
  );
};